import React, {useRef, useState} from "react";

import { Box } from "react-bulma-components";
import { Columns } from "react-bulma-components";
import { Form } from "react-bulma-components";
import {formatDate, readableDate} from "../../utils";
import { Button } from "react-bulma-components";
import Collapsible from "react-collapsible";
import {asyncContainer, Typeahead} from "react-bootstrap-typeahead";
import { Icon } from "react-bulma-components";
import axios from "axios";
import {createSetVehicleFieldAction} from "../../actions/dataActions";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faPoundSign} from "@fortawesome/free-solid-svg-icons";
import DepartmentSelector from "../Settings/Departments/DepartmentSelector";
import ReactToPrint from "react-to-print";
import PrintOrderForm from "./PrintOrderForm";

const AsyncTypeahead = asyncContainer(Typeahead);

function OrderingInfoSection(props) {
  const [isLoading, setLoading] = useState(false);
  const [searchData, setSearchData] = useState([]);
  const [, setTypeahead] = useState();
  const printOrderInfo = useRef();

  const getNewOrder = (order) => {
      // Recalcs purchase price
      if ((order.dealer_discount || order.dealer_discount === 0) && (order.manufacturer_discount || order.manufacturer_discount === 0) && order.retail_price) {
        let newPurchasePrice = (order.retail_price - ((1 * order.manufacturer_discount + 1 * order.dealer_discount) / 100) * order.retail_price)
            + 1 * (order.body_aux_price | 0) + 1 * (order.delivery_charge | 0) + 1 * (order.extra_cost | 0);

        newPurchasePrice = Math.round( (newPurchasePrice * 100) ) / 100;

        order['ordered_purchase_price'] = newPurchasePrice
      }
      return order
  }



  const onChange = e => {
      let newOrder = {...props.data};
      newOrder[e.target.name] = e.target.value;

      newOrder = getNewOrder(newOrder);

      props.onChange(newOrder, props.index);
  }

  const getColor = () => {
      if(!(!!props.data.purchase_invoice_number)){
          return "table-highlight-orange"
      }
      else{
          return ""
      }
  }

  const onDepartmentChange = e => {
      // props.departmentObjects
      const toUpdate = {
          target: {
              name: e.target.name,
              value: props.departmentObjects[e.target.value]
          }
      };
      onChange(toUpdate)
  }

  const handleSupplierSearch = e => {
    setLoading(true);
    axios.get(`/api/contacts?contact_type=SP&search=${e}`).then(resp => {
      setSearchData(resp.data.results);
      setLoading(false);
    });
  };

  const handleCustomerSearch = e => {
    setLoading(true);
    axios.get(`/api/contacts?contact_type=CC&search=${e}`).then(resp => {
      setSearchData(resp.data.results);
      setLoading(false);
    });
  };

  const handleVehicleSupplierSelect = supplier => {
    onChange({target: {name: 'vehicle_supplier', value: supplier[0]}})
  };

  const handleReserveCustomerSelect = reserve_customer => {
    onChange({target: {name: 'reserve_customer', value: reserve_customer[0]}})
  };



  const onCalcChange = e => {
    const body_aux_price = e.target.name === "body_aux_price" ? e.target.value : props.data.body_aux_price;
    const delivery_charge = e.target.name === "delivery_charge" ? e.target.value : props.data.delivery_charge;
    const extra_cost = e.target.name === "extra_cost" ? e.target.value : props.data.extra_cost;
    onChange(e);
    if ((props.data.dealer_discount || props.data.dealer_discount === 0) && (props.data.manufacturer_discount || props.data.manufacturer_discount === 0) && props.data.retail_price) {
      const newPurchasePrice = (props.data.retail_price - ((1 * props.data.dealer_discount + 1 * props.data.manufacturer_discount) / 100) * props.data.retail_price) + 1 * (body_aux_price | 0) + 1 * (delivery_charge | 0) + 1 * (extra_cost | 0)  ;
      onChange({target: {name: 'ordered_purchase_price', value: newPurchasePrice}})
    }

  };

  const handleCheckbox = e => {
    const {name, checked} = e.target;
    onChange({target: {name, value: checked}});
  };

  const generateOrderNumber = () => {
      const conf = {
          url: props.endpoint+"vehicles/generateordernumber",
          method:"get"
      }
      axios(conf).then(resp => {
          const toUpdate = {
              target: {
                  name: "order_number",
                  value: resp.data['order_number']
              }
          }
          onChange(toUpdate);
      })
  }

  return (<Box>
    <Collapsible
      className={`title ${getColor()}`}
      triggerOpenedClassName={`title ${getColor()}`}
      trigger={`Ordering Info - ${props.data.department ? props.data.department.name : ""} - ${props.data.ordered_date ? readableDate(props.data.ordered_date) : ""}`}
    >
      <div>
        <Columns>
          <Columns.Column>
            <Form.Field>
              <Form.Label>Retail Price (*)</Form.Label>
              <Form.Control>
                <Form.Input
                  type="number"
                  name="retail_price"
                  onChange={onChange}
                  value={props.data.retail_price}
                />
                <Icon align={"left"} className={"small-icon"}>
                  <FontAwesomeIcon icon={faPoundSign}/>
                </Icon>
              </Form.Control>
            </Form.Field>
          </Columns.Column>

          <Columns.Column>
            <Form.Field>
              <Form.Label>Dealer Discount (%) (*)</Form.Label>
              <Form.Control>
                <Form.Input
                  type="number"
                  name="dealer_discount"
                  onChange={onChange}
                  value={props.data.dealer_discount}
                />
              </Form.Control>
            </Form.Field>
          </Columns.Column>
          <Columns.Column>
            <Form.Field>
              <Form.Label>Manufacturer Discount (%)</Form.Label>
              <Form.Control>
                <Form.Input
                  type="number"
                  name="manufacturer_discount"
                  onChange={onChange}
                  value={props.data.manufacturer_discount}
                />
              </Form.Control>
            </Form.Field>
          </Columns.Column>
          <Columns.Column>
            <Form.Field>
              <Form.Label>Body/Auxiliaries Price</Form.Label>
              <Form.Control>
                <Form.Input
                  type="text"
                  name="body_aux_price"
                  onChange={onChange}
                  value={props.data.body_aux_price}
                />
                <Icon align={"left"} className={"small-icon"}>
                  <FontAwesomeIcon icon={faPoundSign}/>
                </Icon>
              </Form.Control>
            </Form.Field>
          </Columns.Column>
          <Columns.Column>
            <Form.Field>
              <Form.Label>Delivery Charge</Form.Label>
              <Form.Control>
                <Form.Input
                  type="number"
                  name="delivery_charge"
                  onChange={onChange}
                  value={props.data.delivery_charge}
                />
                <Icon align={"left"} className={"small-icon"}>
                  <FontAwesomeIcon icon={faPoundSign}/>
                </Icon>
              </Form.Control>
            </Form.Field>
          </Columns.Column>
          <Columns.Column>
            <Form.Field>
              <Form.Label>Extra Costs</Form.Label>
              <Form.Control>
                <Form.Input
                  type="text"
                  name="extra_cost"
                  onChange={onChange}
                  value={props.data.extra_cost}
                />
                <Icon align={"left"} className={"small-icon"}>
                  <FontAwesomeIcon icon={faPoundSign}/>
                </Icon>
              </Form.Control>
            </Form.Field>
          </Columns.Column>
            <Columns.Column>
            <Form.Field>
              <Form.Label>Purchase Price (*)</Form.Label>
              <Form.Control>
                <Form.Input
                  type="text"
                  name="ordered_purchase_price"
                  onChange={onChange}
                  value={props.data.ordered_purchase_price}
                />
                <Icon align={"left"} className={"small-icon"}>
                  <FontAwesomeIcon icon={faPoundSign}/>
                </Icon>
              </Form.Control>
            </Form.Field>
          </Columns.Column>
        </Columns>
        <Columns>
          <Columns.Column>
            <Form.Field>
              <Form.Control>
                <Form.Label>Ordered Date (*)</Form.Label>
                <Form.Input
                  type="date"
                  name="ordered_date"
                  onChange={onChange}
                  value={String(props.data.ordered_date)}
                />
              </Form.Control>
            </Form.Field>
          </Columns.Column>
          <Columns.Column>
            <Form.Label>Order Number (*)</Form.Label>
            <Form.Field className={"has-addons"}>
              <Form.Control>
                <Form.Input
                  type="text"
                  name="order_number"
                  onChange={onChange}
                  value={props.data.order_number}
                />
              </Form.Control>
              <Form.Control>
              <Button
                color={"success"}
                onClick={generateOrderNumber}
              >
                  Generate
              </Button>
            </Form.Control>
            </Form.Field>
          </Columns.Column>
          <Columns.Column>
            <Form.Field>
              <Form.Label>Deposit to be paid</Form.Label>
              <Form.Control>
                <Form.Input
                  type="text"
                  name="deposit_to_be_paid"
                  onChange={onChange}
                  value={props.data.deposit_to_be_paid}
                />
                <Icon align={"left"} className={"small-icon"}>
                  <FontAwesomeIcon icon={faPoundSign}/>
                </Icon>
              </Form.Control>
            </Form.Field>
          </Columns.Column>
          <Columns.Column>
            <Form.Field>
              <Form.Control>
                <Form.Label>Deposit Allocated Date</Form.Label>
                <Form.Input
                  type="date"
                  name="deposit_allocated_date"
                  onChange={onChange}
                  value={String(props.data.deposit_allocated_date)}
                />
              </Form.Control>
            </Form.Field>
          </Columns.Column>
          <Columns.Column>
            <Form.Field>
              <Form.Control>
                <Form.Label>Month Due (*)</Form.Label>
                <Form.Input
                  type="month"
                  name="month_due"
                  onChange={onChange}
                  value={String(props.data.month_due)}
                />
              </Form.Control>
            </Form.Field>
          </Columns.Column>
          <Columns.Column>
            <Form.Field>
              <Form.Control>
                <Form.Label>Delivery Date</Form.Label>
                <Form.Input
                  type="date"
                  name="delivery_date"
                  onChange={onChange}
                  value={String(props.data.delivery_date)}
                />
              </Form.Control>
            </Form.Field>
          </Columns.Column>
          <Columns.Column>
            <Form.Field>
              <Form.Control>
                <Form.Label>Delivery Confirmed</Form.Label>
                <Form.Checkbox
                  type="checkbox"
                  name="delivery_date_confirmed"
                  onChange={handleCheckbox}
                  checked={props.data.delivery_date_confirmed}
                />
              </Form.Control>
            </Form.Field>
          </Columns.Column>
          <Columns.Column>
            <Form.Field>
              <Form.Label>Spec</Form.Label>
              <Form.Control>
                <Form.Input
                  type="text"
                  name="spec"
                  onChange={onChange}
                  value={props.data.spec}
                />
              </Form.Control>
            </Form.Field>
          </Columns.Column>
          {/*<Columns.Column>*/}
          {/*  <Form.Field>*/}
          {/*    <Form.Label>Customer Reservation</Form.Label>*/}
          {/*    <Form.Control>*/}
          {/*      <Form.Input*/}
          {/*        type="text"*/}
          {/*        name="customer_reservation"*/}
          {/*        onChange={props.onChange}*/}
          {/*        value={props.data.customer_reservation}*/}
          {/*      />*/}
          {/*    </Form.Control>*/}
          {/*  </Form.Field>*/}
          {/*</Columns.Column>*/}

        </Columns>
        <Columns>
          <Columns.Column>
                <DepartmentSelector
                    options={props.departments}
                    value={props.data.department}
                    label={"New Department Owner (*)"}
                    blank={true}
                    onChange={onDepartmentChange}
                    disabled={false}
                    name={"department"}
                />
          </Columns.Column>
          <Columns.Column>
            <Form.Field>
              <Form.Label>Supplier (*)</Form.Label>
              <Form.Control>
                <AsyncTypeahead
                  useCache={false}
                  id="typeahead"
                  labelKey="display_name"
                  minLength={2}
                  name={"vehicle_supplier"}
                  onSearch={handleSupplierSearch}
                  onChange={handleVehicleSupplierSelect}
                  placeholder={"Search Supplier"}
                  options={searchData}
                  ref={typeahead => setTypeahead(typeahead)}
                  className="typeahead"
                  isLoading={isLoading}
                  selected={props.data.vehicle_supplier && props.data.vehicle_supplier.id ? [props.data.vehicle_supplier] : []}
                />
              </Form.Control>
            </Form.Field>
          </Columns.Column>
          <Columns.Column>
            <Form.Field>
              <Form.Label>Reserve Customer</Form.Label>
              <Form.Control>
                <AsyncTypeahead
                  useCache={false}
                  id="typeahead"
                  labelKey="display_name"
                  minLength={2}
                  name={"reserve_customer"}
                  onSearch={handleCustomerSearch}
                  onChange={handleReserveCustomerSelect}
                  placeholder={"Search Customer"}
                  options={searchData}
                  ref={typeahead => setTypeahead(typeahead)}
                  className="typeahead"
                  isLoading={isLoading}
                  selected={props.data.reserve_customer && props.data.reserve_customer.id ? [props.data.reserve_customer] : []}
                />
              </Form.Control>
            </Form.Field>
          </Columns.Column>
          <Columns.Column>
            <Form.Field>
              <Form.Label>Invoice Number</Form.Label>
              <Form.Control>
                <Form.Input
                  type="text"
                  name="purchase_invoice_number"
                  onChange={onChange}
                  value={props.data.purchase_invoice_number}
                />
              </Form.Control>
            </Form.Field>
          </Columns.Column>
          <Columns.Column>
            <Form.Field>
              <Form.Label>DEPR</Form.Label>
              <Form.Control>
                <Form.Input
                  type="text"
                  name="depr"
                  onChange={onChange}
                  value={props.data.depr}
                />
              </Form.Control>
            </Form.Field>
          </Columns.Column>
          <Columns.Column>
            <Form.Field>
              <Form.Label>Status</Form.Label>
              <Form.Control>
                <Form.Input
                  type="text"
                  name="status"
                  onChange={onChange}
                  value={props.data.status}
                />
              </Form.Control>
            </Form.Field>
          </Columns.Column>
          <Columns.Column>
            <Form.Field>
              <Form.Label>Exchange Vehicle</Form.Label>
              <Form.Control>
                <Form.Input
                  type="text"
                  name="exchange_vehicle"
                  onChange={onChange}
                  value={props.data.exchange_vehicle}
                />
              </Form.Control>
            </Form.Field>
          </Columns.Column>
        </Columns>
        <Columns>
        </Columns>
        <Columns>
          <Columns.Column>
            <Form.Field>
              <Form.Label>Extras</Form.Label>
              <Form.Control>
                <Form.Input
                  type="text"
                  name="extras"
                  onChange={onChange}
                  value={props.data.extras}
                />
              </Form.Control>
            </Form.Field>
          </Columns.Column>
          <Columns.Column>
            <Form.Field>
              <Form.Label>Comments</Form.Label>
              <Form.Control>
                <Form.Input
                  type="text"
                  name="ordering_comments"
                  onChange={onChange}
                  value={props.data.ordering_comments}
                />
              </Form.Control>
            </Form.Field>
          </Columns.Column>
        </Columns>
        <Columns>
            <Columns.Column>
                <Button
                    color={"danger"}
                    onClick={e => props.removeOrder(props.index)}
                >
                    Remove Order
                </Button>
            </Columns.Column>
            <Columns.Column>
                <Form.Control className={"has-addons"}>
                      <Form.Field>
                          <ReactToPrint
                              trigger={() => (
                                  <Button color="warning">
                                     Print Order Form
                                  </Button>
                              )}
                              content={() => printOrderInfo.current}
                              bodyClass="print-portrait"
                              pageStyle="@page {
                            size: A4 portrait;
                          }"
                          />
                      </Form.Field>
                </Form.Control>
            </Columns.Column>
        </Columns>
        <div style={{display: "none"}}>
          <div>
            <PrintOrderForm ref={printOrderInfo} order={props.data} vehicle={props.vehicle}/>
          </div>
        </div>
      </div>
    </Collapsible>
  </Box>);
}

export default OrderingInfoSection;
